import {
  jb_in_text_teaser_css_default
} from "./chunk.JXPYKQDH.js";
import {
  Linkable,
  Spaceable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.P6YYTXAQ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-in-text-teaser/jb-in-text-teaser.ts
var JbInTextTeaser = class extends Linkable(Spaceable(r)) {
  firstUpdated() {
    if (!this.link) {
      this.style.setProperty("display", "none");
    }
  }
  _getContentSpacingProperties() {
    return { type: "text", colsMdUp: "none" };
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "in-text-teaser",
      interaction_text: this.buttonLabel
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    const imgData = this.image;
    return ke`<header>
        <div>${this.kicker ? ke`<h4>${this.kicker}</h4>` : D}</div>
        <div>
          ${this.market ? ke`<jb-globe-icon></jb-globe-icon
                ><jb-market-display
                  .marketName=${this.market.marketName}
                  .marketShortName=${this.market.marketShortName}
                ></jb-market-display>` : D}
        </div>
      </header>
      <section class=${Rt({ "no-image": !imgData })}>
        ${imgData ? ke`<div class="image-wrap">
              <a
                data-linkable
                @jb-link:clicked=${this._tracking}
              >
                <jb-picture
                  .imgData=${imgData}
                  aspect="aspect_3by2"
                  fit="cover"
                ></jb-picture>
              </a>
            </div>` : D}
        <div class="text-wrap">
          <a
            data-linkable
            @jb-link:clicked=${this._tracking}
          >
            <h3>${this.headline}</h3>
            ${this.text ? ke`<p>${this.text}</p>` : D}
          </a>
          ${this.buttonLabel ? ke`<jb-button-secondary
                .link=${this.link}
                @jb-link:clicked=${this._tracking}
                >${this.buttonLabel}</jb-button-secondary
              >` : D}
        </div>
      </section>`;
  }
};
JbInTextTeaser.styles = jb_in_text_teaser_css_default;
__decorateClass([
  n()
], JbInTextTeaser.prototype, "buttonLabel", 2);
__decorateClass([
  n()
], JbInTextTeaser.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbInTextTeaser.prototype, "image", 2);
__decorateClass([
  n()
], JbInTextTeaser.prototype, "kicker", 2);
__decorateClass([
  n({ type: Object })
], JbInTextTeaser.prototype, "market", 2);
__decorateClass([
  n()
], JbInTextTeaser.prototype, "text", 2);
JbInTextTeaser = __decorateClass([
  customElement("jb-in-text-teaser")
], JbInTextTeaser);

export {
  JbInTextTeaser
};
